import React from 'react'
import { Auth } from 'services'
import { Button, AddToHomeScreen } from 'components'
import { Gtm } from 'helpers'
import { PAGE_TYPES } from 'src/constants'

import './Login.scss'

interface State {
    username: string,
    password: string,
    loading: boolean,
    error: boolean | string
}

const auth = new Auth()

export default class Login extends React.Component<Object, State> {

    constructor(props: Object) {
        super(props)
        this.state = {
            username: '',
            password: '',
            loading: false,
            error: false
        }
    }

    public componentDidMount() {
        localStorage.clear()
        document.getElementsByTagName('html')[0].classList.add('page-login')
        // GTM
        Gtm.pushPageType(PAGE_TYPES.LOGIN)
        //  End GTM
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('page-login')
    }

    public handleSubmit = (event: any) => {
        this.setState({
            loading: true,
            error: false
        })
        event.persist()
        event.preventDefault()
        auth.login(this.state)
            .catch(error => {
                this.setState({
                    loading: false,
                    error: error.message
                })
            })
    }

    handleChange = (event: any) => {
        const target = event.target
        const name = target.name

        if ( name === 'email') {
            this.setState({
                username : target.value
            })
        } else {
            this.setState({
                password : target.value
            })
        }

    }

    public render() {
        const { username, password, loading, error } = this.state

        return (
            <form onSubmit={this.handleSubmit}>
                <section className="page-layout">
                    <header>
                        <div className="login-logo">
                            <img
                                className="login-logo__image"
                                src="https://florensis-pim.s3.eu-central-1.amazonaws.com/dam/Website/General/FlorensisLogo.png"
                                alt="logo Florensis"
                            />
                        </div>
                    </header>
                    <main>
                        <div className="login-container">
                            <label htmlFor="email" className="form-label">Email</label>
                            <div className="input-row">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    placeholder="Your username"
                                    onChange={this.handleChange}
                                    required={true}
                                />
                            </div>
                            <label htmlFor="password" className="form-label">Password</label>
                            <div className="input-row">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    placeholder="Your password"
                                    onChange={this.handleChange}
                                    required={true}
                                />
                            </div>
                            { error &&
                                <div className="error-message">
                                    {error}
                                </div>
                            }
                        </div>
                    </main>
                    <footer>
                        <a
                            href="https://www.florensis.com/en-gb/account/login"
                            className="text-link u-text--centered"
                            target="_blank"
                        >Request an account
                        </a>
                        <Button
                            type="submit"
                            className="u-margin-top--md"
                            disabled={username  === '' || password === ''}
                            loading={loading}
                            variant="primary"
                            full={true}
                        >
                            Log in
                        </Button>
                    </footer>
                </section>
                <AddToHomeScreen />
            </form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Login/index.tsx